import { Label } from "@/components/ui/label";

/**
 * Pequeño helper visual: etiqueta en mayúsculas + control (input/select/etc.).
 * Extraído desde `UploadInvoiceModal.jsx` para reutilizar en subcomponentes.
 */
export default function Field({ label, children, testid }) {
  return (
    <div className="space-y-1.5" data-testid={testid}>
      <Label className="text-xs uppercase tracking-wider text-[var(--text-secondary)]">
        {label}
      </Label>
      {children}
    </div>
  );
}
